"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomizerContext = void 0;
var React = require("react");
exports.CustomizerContext = React.createContext({
    customizations: {
        inCustomizerContext: false,
        settings: {},
        scopedSettings: {},
    },
});
//# sourceMappingURL=CustomizerContext.js.map